const Login = () => /* webpackChunkName: "Login" */ import("./../views/Login.vue");

import { routes as administravieRoutes } from "./administrative";
import { routes as administratorRoutes } from "./administrator";
import { routes as medicApsRoutes } from "./medicAps";
import { routes as medicHospRoutes } from "./medicHosp";
import { routes as someApsRoutes } from "./someAps";
import { routes as someHcmRoutes } from "./someHcm";
import { routes as mediContraApsRoutes } from "./mediContraAps";
import { routes as mediContraHcmRoutes } from "./mediContraHcm";
import { routes as samuRoutes } from "./samu";
import { routes as mentalHealthMedic } from "./mental_health_medic";
import { routes as pharmacyMedic } from "./mental_health_pharmacy";
import { routes as archive } from "./archive";
import { routes as someArchive } from "./someArchive";
import { routes as ManagementControl } from "./managementControl";
import { routes as ServiceHosp } from "./serviceHosp";

import { routes as Grd } from "./grd";

import { routes as Admision } from "./admision";
import { routes as serviceAdministrator } from "./service_administrator";
import { routes as professionalNoMedic } from "./professional_no_medic";
import { routes as MentalHealth } from "./mental_health";
import { routes as gestorAps } from "./gestor_aps";
import { routes as administrativeAps } from "./administrative_aps";

//IMPORT DE LAS RUTAS DE LAS VISTAS DE LOS SERVICIOS
export const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "login",
    component: Login,
  },
  ...administravieRoutes,
  ...administratorRoutes,
  ...medicApsRoutes,
  ...medicHospRoutes,
  ...someApsRoutes,
  ...someHcmRoutes,
  ...mediContraApsRoutes,
  ...mediContraHcmRoutes,
  ...samuRoutes,
  ...mentalHealthMedic,
  ...pharmacyMedic,
  ...archive,
  ...ManagementControl,
  ...someArchive,
  ...ServiceHosp,
  ...Grd,
  ...Admision,
  ...MentalHealth,
  ...serviceAdministrator,
  ...professionalNoMedic,
  ...administrativeAps,
  ...gestorAps,
  {
    path: "*",
    redirect: "/",
  },
];
